const ANALYTICS_KEY = "G-GGJ1XCRPM0";

export default ANALYTICS_KEY;
